"use client";
import React from "react";

interface CheckRadioProps {
  type: "radio" | "checkbox";
  id?: string;
  name?: string;
  className?: string;
  disabled?: boolean;
  label?: string;
  defaultChecked?: boolean;
  checked?: boolean;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  labelClassName?: string;
}

const CCheckRadio = ({
  type,
  id,
  name,
  className,
  label,
  defaultChecked,
  checked,
  disabled,
  onClick,
  onChange,
  labelClassName,
}: CheckRadioProps) => {
  // Get user role from localStorage if color prop is not provided
  let detectedRole = "admin";
  if (typeof window !== "undefined") {
    try {
      const userStr = localStorage.getItem("user");
      if (userStr) {
        const userObj = JSON.parse(userStr);
        detectedRole = userObj?.user_type === "client" ? "client" : "admin";
      }
    } catch {}
  }
  const accentColor =
    detectedRole === "client"
      ? "accent-client-primary focus:ring-client-primary"
      : "accent-primary focus:ring-primary";
  return (
    <div className="flex items-center gap-2">
      <input
        onClick={onClick}
        type={type}
        name={name}
        id={id}
        defaultChecked={defaultChecked}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={`${className} h-3 w-3 ${accentColor} border-border rounded ${
          disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
        }`}
      />
      {label && (
        <label
          htmlFor={id}
          className={`text-sm text-foreground ${
            disabled ? "opacity-50 cursor-not-allowed" : ""
          } ${labelClassName}`}
          data-testid="check-radio-label"
        >
          {label}
        </label>
      )}
    </div>
  );
};
export default CCheckRadio;
